import { RouteFragment } from "../RouteFragment";
import { RouteFragmentDetails } from "../RouteFragmentDetails";
import { RouteParams } from "../RouteParams";
import { RouteSort } from "../RouteSort";
import { SortingOptions } from "@/sorting/SortingOptions";

export class RouteRanking extends RouteSort {

	public static readonly fragmentType: typeof RouteRanking = RouteRanking;

	public constructor() {
		super(
			"Ranking",
			SortingOptions.UNIVERSITY_META_RANKING,
			new RouteFragmentDetails(RouteParams.SORT, [{
				value: 'rankings',
				path: 'rankings',
				pathAlternatives: [],
			}]),
			"rankings"
		);
	}

	public instantiate(): RouteFragment {
		return new RouteRanking();
	}
}
